var map = {
  "./en-SG": "585383",
  "./en-SG.js": "585383",
  "./en-au": "278348",
  "./en-au.js": "278348",
  "./en-ca": "477925",
  "./en-ca.js": "477925",
  "./en-gb": "522243",
  "./en-gb.js": "522243",
  "./en-ie": "46436",
  "./en-ie.js": "46436",
  "./en-il": "947207",
  "./en-il.js": "947207",
  "./en-nz": "476319",
  "./en-nz.js": "476319"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 928622;
